export enum EAppService {
  AppStore = 'AppStoreButton',
  GooglePlay = 'GooglePlayButton',
}

export const appsButtons = [
  {
    name: EAppService.GooglePlay,
    title: 'Google Play',
    className: 'google-btn',
  },
  {
    name: EAppService.AppStore,
    title: 'App Store',
    className: 'apple-btn',
  },
];
